import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
class ClasseForm extends Component {
    state = {
        id: "",
        entitled_class: "",
        short_entitled_class: "",
        error: "",
        title: "",
        saving: false,
    };

    handleInput = (event) => this.setState({ [event.target.name]: event.target.value });

    storeClasse = async () => {
        const entitledClass = this.state.entitled_class.trim();
        const shortEntitledClass = this.state.short_entitled_class.trim();
        if (!entitledClass || !shortEntitledClass) {
            this.setState({ error: "Complétez les deux champs avant de sauvegarder." });
            return;
        }

        const data = {
            entitled_class: entitledClass,
            short_entitled_class: shortEntitledClass,
            operation: this.state.id ? "Editer" : "Ajouter",
        };
        const request = this.state.id ? axios.put(`classes/${this.state.id}`, data) : axios.post("classes", data);
        this.setState({ saving: true, error: "" });
        try {
            const response = await request;
            this.props.showModal();
            toast.success(response?.data?.msg || "Le niveau de classe a été sauvegardé.");
        } catch (error) {
            const message = error.response?.data?.msg || "La sauvegarde a échoué.";
            this.setState({ error: message });
            toast.error(message);
        } finally {
            this.setState({ saving: false });
        }
    };

    form = () => {
        const item = this.props.formData;
        this.setState({
            id: item?.id || "",
            entitled_class: item?.entitled_class || "",
            short_entitled_class: item?.short_entitled_class || "",
            title: item ? "Modifier le niveau" : "Ajouter un niveau",
            error: "",
            saving: false,
        });
    };

    render() {
        const editing = Boolean(this.state.id);
        return (
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                onEntered={this.form}
                backdrop="static"
                centered
                dialogClassName="sectionclasse-form classe-form"
            >
                <Modal.Header className="sectionclasse-form__header">
                    <div className="sectionclasse-form__title">
                        <span><FeatherIcon icon={editing ? "edit-3" : "layers"} size={20} /></span>
                        <div>
                            <small>Configuration pédagogique</small>
                            <Modal.Title>{this.state.title}</Modal.Title>
                        </div>
                    </div>
                    <button type="button" className="sectionclasse-form__close" onClick={this.props.showModal} aria-label="Fermer">
                        <FeatherIcon icon="x" size={18} />
                    </button>
                </Modal.Header>
                <Modal.Body className="sectionclasse-form__body">
                    <p className="sectionclasse-form__intro">Créez un niveau de référence qui pourra ensuite être rattaché aux sections et aux groupes.</p>
                    {this.state.error && <div className="sectionclasse-form__alert" role="alert"><FeatherIcon icon="alert-circle" size={17} />{this.state.error}</div>}
                    <div className="row g-3">
                        <div className="col-md-7">
                            <label className="sectionclasse-field__label" htmlFor="classe-entitled"><FeatherIcon icon="book" size={15} />Nom du niveau <b>*</b></label>
                            <input type="text" className="sectionclasse-text-field" placeholder="Exemple : Sixième année" onChange={this.handleInput} name="entitled_class" value={this.state.entitled_class} id="classe-entitled" />
                            <small className="sectionclasse-field__hint">Utilisez l’intitulé complet affiché dans les listes.</small>
                        </div>
                        <div className="col-md-5">
                            <label className="sectionclasse-field__label" htmlFor="classe-short"><FeatherIcon icon="tag" size={15} />Abréviation <b>*</b></label>
                            <input type="text" className="sectionclasse-text-field" placeholder="Exemple : 6e" onChange={this.handleInput} name="short_entitled_class" value={this.state.short_entitled_class} id="classe-short" />
                            <small className="sectionclasse-field__hint">Courte, claire et sans nom de section.</small>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="sectionclasse-form__footer">
                    <Link to="/manuel#classes" className="classe-form__documentation"><FeatherIcon icon="book-open" size={15} />Documentation</Link>
                    <div>
                        <button type="button" onClick={this.props.showModal} className="sectionclasse-form__cancel">Annuler</button>
                        <button type="button" onClick={this.storeClasse} className="sectionclasse-form__save" disabled={this.state.saving}>
                            {this.state.saving ? <><span className="spinner-border spinner-border-sm" />Sauvegarde…</> : <><FeatherIcon icon="check" size={17} />{editing ? "Actualiser" : "Créer le niveau"}</>}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ClasseForm;
